import { render, staticRenderFns } from "./ColumnChart.vue?vue&type=template&id=1baa0e1f&scoped=true"
import script from "./ColumnChart.vue?vue&type=script&lang=ts"
export * from "./ColumnChart.vue?vue&type=script&lang=ts"
import style0 from "./ColumnChart.vue?vue&type=style&index=0&id=1baa0e1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa0e1f",
  null
  
)

export default component.exports